import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Admin Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProjectDetails from './pages/ProjectDetails';
import Profile from './pages/Profile';
import UserManagement from './pages/UserManagement';
import ClientManagement from './pages/ClientManagement';

// Public Pages
import PublicIndex from './pages/public/Index.tsx';
import PublicProducts from './pages/public/Products.tsx';
import PublicAbout from './pages/public/About.tsx';
import PublicServices from './pages/public/Services.tsx';
import PublicQuality from './pages/public/Quality.tsx';
import PublicDownloads from './pages/public/Downloads.tsx';
import PublicContact from './pages/public/Contact.tsx';

// Components
import Header from './components/Header';
import PrivateRoute from './components/PrivateRoute';

// Context
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={
                <>
                  {console.log('🏠 App.js: Rendering PublicIndex for root path')}
                  <PublicIndex />
                </>
              } />
              <Route path="/products" element={<PublicProducts />} />
              <Route path="/about" element={<PublicAbout />} />
              <Route path="/services" element={<PublicServices />} />
              <Route path="/quality" element={<PublicQuality />} />
              <Route path="/downloads" element={<PublicDownloads />} />
              <Route path="/contact" element={<PublicContact />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
              <Route path="/admin/login" element={
                <div>
                  <ToastContainer position="top-right" autoClose={3000} />
                  <Login />
                </div>
              } />
              <Route path="/admin/dashboard" element={
                <div>
                  <Header />
                  <ToastContainer position="top-right" autoClose={3000} />
                  <main className="container py-4">
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  </main>
                </div>
              } />
              <Route path="/admin/project/:id" element={
                <div>
                  <Header />
                  <ToastContainer position="top-right" autoClose={3000} />
                  <main className="container py-4">
                    <PrivateRoute>
                      <ProjectDetails />
                    </PrivateRoute>
                  </main>
                </div>
              } />
              <Route path="/admin/profile" element={
                <div>
                  <Header />
                  <ToastContainer position="top-right" autoClose={3000} />
                  <main className="container py-4">
                    <PrivateRoute>
                      <Profile />
                    </PrivateRoute>
                  </main>
                </div>
              } />
              <Route path="/admin/users" element={
                <div>
                  <Header />
                  <ToastContainer position="top-right" autoClose={3000} />
                  <main className="container py-4">
                    <PrivateRoute>
                      <UserManagement />
                    </PrivateRoute>
                  </main>
                </div>
              } />
              <Route path="/admin/clients" element={
                <div>
                  <Header />
                  <ToastContainer position="top-right" autoClose={3000} />
                  <main className="container py-4">
                    <PrivateRoute>
                      <ClientManagement />
                    </PrivateRoute>
                  </main>
                </div>
              } />
            </Routes>
          </div>
        </Router>
    </AuthProvider>
  );
}

export default App;
